import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";

function fmt(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export default function ArticleCard({ article, featured = false }) {
  if (featured) {
    return (
      <Link
        to={`/insights/${article.slug}`}
        data-testid={`article-card-${article.slug}`}
        className="card-hover group grid grid-cols-1 overflow-hidden rounded-xl border border-slate-200 bg-white md:grid-cols-2"
      >
        <div className="h-56 overflow-hidden md:h-full">
          <img src={article.image} alt={article.title} loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        </div>
        <div className="flex flex-col justify-center p-7">
          <span className="eyebrow">{article.category}</span>
          <h3 className="mt-3 font-serif text-2xl font-semibold text-navy">{article.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-slate-600 line-clamp-3">{article.excerpt}</p>
          <div className="mt-4 flex items-center gap-4 text-xs text-slate-500">
            <span className="flex items-center gap-1"><Calendar size={13} /> {fmt(article.published_at)}</span>
            {article.read_minutes && <span className="flex items-center gap-1"><Clock size={13} /> {article.read_minutes} min read</span>}
          </div>
          <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-gold">
            Read Article <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    );
  }
  return (
    <Link
      to={`/insights/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="card-hover group flex flex-col overflow-hidden rounded-xl border border-slate-200 bg-white"
    >
      <div className="h-44 overflow-hidden">
        <img src={article.image} alt={article.title} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      </div>
      <div className="flex flex-1 flex-col p-5">
        <span className="eyebrow text-[11px]">{article.category}</span>
        <h3 className="mt-2 font-serif text-lg font-semibold leading-snug text-navy line-clamp-2">{article.title}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600 line-clamp-2">{article.excerpt}</p>
        <div className="mt-3 flex items-center gap-3 text-xs text-slate-500">
          <span className="flex items-center gap-1"><Calendar size={12} /> {fmt(article.published_at)}</span>
          {article.read_minutes && <span className="flex items-center gap-1"><Clock size={12} /> {article.read_minutes} min</span>}
        </div>
      </div>
    </Link>
  );
}
